export default __webpack_public_path__ + "static/media/MichelleGTestimonial.7ec01c02.png";